import { buildCoursesPath } from '@/composables/locale/useIndexRoutes'

/** Фіксовані сегменти під /:locale (не категорії курсів) */
const LOCALE_FIXED_SEGMENTS = new Set([
  'about',
  'contacts',
  'articles',
  'events',
  'courses',
  'privacy-policy',
  'terms',
  'program-details',
])

/**
 * Редірект /:locale/:category → /:locale/courses/:category
 * та /:locale/:category/:slug → /:locale/courses/:category/:slug
 * (старі URL категорій курсів).
 */
export default defineNuxtRouteMiddleware((to) => {
  const match = to.path.match(/^\/([a-z]{2}(?:-[A-Za-z]+)?)\/([^/]+)(?:\/(.+))?$/)
  if (!match) return
  const [, locale, segment, slug] = match
  if (!locale || !segment || LOCALE_FIXED_SEGMENTS.has(segment)) return
  const target = slug
    ? buildCoursesPath(locale, segment, slug)
    : buildCoursesPath(locale, segment)
  return navigateTo(target, { replace: true })
})